import React from "react";
import { ReactComponent as RightBox } from "images/background/right-box-graphic.svg";
import "./UseCases.css";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

export default function Index({ data }) {
  return (
    <section className="popular-use-case">
      <RightBox className="right-box-shape" />
      <div className="container">
        <div className="title">
          <h2>Popular Use Cases</h2>
        </div>
        <div className="row">
          {data.use_cases.length > 0
            ? data.use_cases.map((item) => (
                <div className="col-lg-4">
                  <div className="use-case">
                    <Link to={item.link} className="accent">
                    <h5>{item.title}</h5>
                    <img src={item.img} alt="goopter flashbot" />
                      <FormattedMessage id="read_more" />
                    </Link>
                  </div>
                </div>
              ))
            : null}
        </div>
      </div>
    </section>
  );
}
